// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#printView {
    width: 21cm; /* Chiều rộng khổ A4 */
    min-height: 29.7cm; /* Chiều cao khổ A4 */
    margin: 0 auto;
    padding: 20px;
    line-height: 1.2;
    font-size: 14px; /* Đảm bảo cỡ chữ đủ lớn */
    font-family: Arial, sans-serif; /* Font chữ rõ nét */
    color: #000; /* Đảm bảo chữ màu đậm */
    background-color: white; /* Nền trắng */
    box-shadow: none;
    position: relative;
}
div {
    display: block;
    unicode-bidi: isolate;
}
.page_a4 {
    padding: 15px 20px;
    position: relative;
    min-height: 1022px;
    box-sizing: border-box;
    margin: 0px;
    overflow: hidden;
    flex-direction: column;
}
/* .table {
    border-collapse: separate;
    text-indent: initial;
    border-spacing: 1px;
} */
body .body-content {
    flex: 1 0 auto;
}
.bkns-sale {
    width: 100%;
    margin: calc(30px + 40px) auto 30px auto;
    display: flex
;
    padding: 10px;
    align-items: center;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
}
marquee {
    display: inline-block;
    width: -webkit-fill-available;
}
/* ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    unicode-bidi: isolate;
} */
ul {
    list-style-type: disc;
}
        .image.size-lg {
    max-width: 230px;
}
.navbar .navbar-left .navbar-brand {
    height: 100%;
}
.orderpage-configuration .card{
border: none;
margin: 3px;
}
.orderpage-configuration .card-body.item
{
padding: 2px;
}

input[type=checkbox]:checked:after, input[type=checkbox]:checked::after, input[type=radio]:checked:after, input[type=radio]:checked::after {
    background: #0693e3;
    border: 2px solid #0693e3;
}

.leftnavigation-box .nav-item .nav-link img {
    display: inline-block !important;
}
.tab-content {
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 2px 24px rgba(0, 0, 0, 0.08);
}
.loyalty-info {
    background-color: #e2edf9;
    padding: 15px;
    border: 1px solid #cadaec;
    font-size: 14px;
}
.txt-green {
    color: #1eba5c;
    margin-right: 5px;
}

.loyalty-info .list-group-ui-base {
    padding: 0;
    margin: 0;
}
.loyalty-info .table thead th {
	border-bottom: 2px solid #ddd;
	font-size: 15px;
}


/**custom**/
.navbar  form.navbar-search .input-group {
    position: relative;
    display: flex;
    align-items: center;
    /*width: 500px !important;*/
    padding: 10px 20px !important;
}

.navbar input#navbar-search-box {
    background-color: transparent;
    border: 1px solid #0693e3 !important;
    height: 40px !important;
}

.navbar .input-group-prepend.input-icon-placeholder {
    position: absolute;
    right: 22px;
    height: 40px !important;
}

.navbar .input-group-prepend.input-icon-placeholder span.navbar-search-icon.input-group-text {
    height: 40px !important;
    background: #0693e3 !important;
    width: 40px !important;
    padding: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px !important;
}

.navbar .input-group-prepend.input-icon-placeholder span.navbar-search-icon.input-group-text i{
    color:#fff !important;
}

.navbar .navbar-body .navbar-menu .nav-item a i {
    color: #0693e3 !important;
}

.navbar .navbar-body .navbar-menu .nav-link {
    color: #333 !important;
    border: 0px !important;
    position:relative;
}

.navbar .navbar-body .navbar-menu .nav-item a.nav-link:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 1px;
    background: #EBECF0;
    right: 0px;
}

.root-boxes .root-box {
    border-width: 2px !important;
    height: 280px;
    padding: 20px !important;
}

.root-boxes .root-box h4 {
    text-transform: uppercase;
    font-size: 22px;
    margin: 0;
    font-weight: 500;
    color: #000;
}


.root-boxes .root-box span {
    text-align: center;
    margin: 20px 0 0 0;
}

.section-main h1,section.section-main h2 {
    color: #0693e3 !important;
    text-transform: uppercase;
    font-size: 28px;
    font-weight: 700;
}
.orderpage .card .card-title {
    color: #fff !important;
    font-size: 16px;
    font-weight: 700 !important;
}
.orderpage-domain_2019 .card .card-title {
    color: #0573b1 !important;
    font-size: 22px;
}
.navbar-order a {
    margin-right: 0px !important;
}

.navbar .navbar-body .navbar-search .input-group .input-icon-placeholder span.navbar-search-icon.input-group-text {
    padding: 0px !important;
}

.navbar .dropdown-order-items.show {
    margin: 0;
}

div#orderpage h1, div#orderpage h2 {
    color: #fff !important;
}

/** update menu**/
.dropdown-item{
color: #222222;
}
.dropdown .dropdown-item {
font-size: 15px;
}
.dropdown-menu.dropdown-menu-right.show{
box-shadow: 0px 0px 15px rgb(0 0 0 / 25%);
border-radius: 6px;
}
.dropdown-menu.dropdown-menu-right.show:after {
    position: absolute;
    content: "";
    width: 0px;
    height: 0px;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #fff;
    top: -10px;
    right: 20px;
}


.bkns-sale {
    width: 100%;
    margin: calc(30px + 40px) auto 30px auto;
    display: flex;
    padding:10px;
    align-items: center;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
}

.bkns-sale ul li {
        position: relative;
    padding-left: 15px;
    display: inline-block;
}

.bkns-sale ul {
    margin: 0px !important;
}

.bkns-sale ul li a {
    font-size: 16px;
    color: #000;
}

.bkns-sale ul li:before {
    content: "";
    width: 5px;
    height: 5px;
    background: #0693e3 !important;
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
}

.bkns-sale .banner_sales {
    padding: 5px 5px 8px 5px;
    background: transparent;
    display: flex;
    width: 150px !important;
    text-align: center;
    border: 1px dashed #ff0000;
    justify-content: center;
    align-items: center;
        margin-left: 50px;
}

.bkns-sale ul li a p {
    margin: 0px !important;
}

.bkns-sale .banner_sales strong {
    font-size: 18px;
    line-height: 22px;
    color: #ff0000;
    font-weight: 700;
    margin: 0px 10px 0px 0px;
}

.banner_sales figure {
    margin: 0;
    position: relative;
}

.banner_sales sup {
   color: #fff;
    position: absolute;
    left: 50%;
    top: 65%;
    transform: translate(-50%,-50%);
    font-size: 15px;
}

.btn-sm {
    padding: 10px 15px !important;
    font-size: 15px !important;
}

.navbar .navbar-body .navbar-search {
    /*width: auto !important;*/
}

.navbar-right {
    display: flex;
    align-items: center;
}

.btn {
    border-radius: 0px !important;
}

.bkns-sale ul li{
    margin-right:50px !important;
}
@media only screen and (max-width:768px){
    .bkns-sale {
    margin: 0;
    display: flex;
}

.bkns-sale .banner_sales strong {
    display: none;
}

.bkns-sale .banner_sales {
    width: 50px !important;
}
}

@media (min-width: 994px) {
    body .body-content .section-main {
        margin: calc(30px + 0px) auto 0px auto !important;
    }
    
}
    .navbar form.navbar-search .input-group{
        /*max-width: 300px !important;*/
    }

   



    .bank-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
        font-size: 14px;
    }
    
    .bank-table th,
    .bank-table td {
        padding: 10px;
        border: 1px solid #ddd;
        text-align: center;
    }
    
    .bank-table th {
        background-color: #f5f5f5;
        font-weight: bold;
    }
    
    .bank-table img {
        display: block;
        margin: 0 auto;
    }
    

    .transfer-btn {
        font-size: 12px; /* Giảm kích thước chữ */
        background-color: #28a745;
        color: white;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        text-align: center;
    }
    
    .transfer-btn:hover {
        background-color: #218838;
    }
    
    
    .payment-notice {
        width: 21cm; 
        margin: 0 auto;
        padding: 20px;
        line-height: 1.2;
        font-size: 14px; 
        font-family: Arial, sans-serif; 
        color: #000; 
        background-color: white; 
        box-shadow: none;
        position: relative;
        /* top: -300px;  */
    }
    
        
    .bank-table
    {
        width: 21cm; /* Chiều rộng khổ A4 */
        margin: 0 auto;
        position: relative;
        /* top: -300px;  */
    }



    .loading-spinner {
        background-color: transparent !important;
    }
    `, "",{"version":3,"sources":["webpack://./src/pages/Invoice/InvoiceDetail.css"],"names":[],"mappings":"AAAA;IACI,WAAW,EAAE,sBAAsB;IACnC,kBAAkB,EAAE,qBAAqB;IACzC,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe,EAAE,0BAA0B;IAC3C,8BAA8B,EAAE,oBAAoB;IACpD,WAAW,EAAE,wBAAwB;IACrC,uBAAuB,EAAE,cAAc;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;;;;GAIG;AACH;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,wCAAwC;IACxC;AACJ;IACI,aAAa;IACb,mBAAmB;IACnB,2CAA2C;AAC/C;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;;;;;;;;;GASG;AACH;IACI,qBAAqB;AACzB;QACQ;IACJ,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;AACA,YAAY;AACZ,WAAW;AACX;AACA;;AAEA,YAAY;AACZ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,4EAA4E;AAChF;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;AACA;CACC,6BAA6B;CAC7B,eAAe;AAChB;;;AAGA,WAAW;AACX;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;AACA,cAAc;AACd;AACA;AACA,eAAe;AACf;AACA;AACA,yCAAyC;AACzC,kBAAkB;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,mCAAmC;IACnC,8BAA8B;IAC9B,UAAU;IACV,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;QACQ,kBAAkB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;QACf,iBAAiB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;GACG,WAAW;IACV,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI;IACA,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;AACA;;AAEA;IACI;QACI,iDAAiD;IACrD;;AAEJ;IACI;QACI,+BAA+B;IACnC;;;;;;IAMA;QACI,WAAW;QACX,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;;IAGA;QACI,eAAe,EAAE,wBAAwB;QACzC,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;;IAGA;QACI,WAAW;QACX,cAAc;QACd,aAAa;QACb,gBAAgB;QAChB,eAAe;QACf,8BAA8B;QAC9B,WAAW;QACX,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;;IAGA;;QAEI,WAAW,EAAE,sBAAsB;QACnC,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;;;IAIA;QACI,wCAAwC;IAC5C","sourcesContent":["#printView {\n    width: 21cm; /* Chiều rộng khổ A4 */\n    min-height: 29.7cm; /* Chiều cao khổ A4 */\n    margin: 0 auto;\n    padding: 20px;\n    line-height: 1.2;\n    font-size: 14px; /* Đảm bảo cỡ chữ đủ lớn */\n    font-family: Arial, sans-serif; /* Font chữ rõ nét */\n    color: #000; /* Đảm bảo chữ màu đậm */\n    background-color: white; /* Nền trắng */\n    box-shadow: none;\n    position: relative;\n}\ndiv {\n    display: block;\n    unicode-bidi: isolate;\n}\n.page_a4 {\n    padding: 15px 20px;\n    position: relative;\n    min-height: 1022px;\n    box-sizing: border-box;\n    margin: 0px;\n    overflow: hidden;\n    flex-direction: column;\n}\n/* .table {\n    border-collapse: separate;\n    text-indent: initial;\n    border-spacing: 1px;\n} */\nbody .body-content {\n    flex: 1 0 auto;\n}\n.bkns-sale {\n    width: 100%;\n    margin: calc(30px + 40px) auto 30px auto;\n    display: flex\n;\n    padding: 10px;\n    align-items: center;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);\n}\nmarquee {\n    display: inline-block;\n    width: -webkit-fill-available;\n}\n/* ul {\n    display: block;\n    list-style-type: disc;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n    padding-inline-start: 40px;\n    unicode-bidi: isolate;\n} */\nul {\n    list-style-type: disc;\n}\n        .image.size-lg {\n    max-width: 230px;\n}\n.navbar .navbar-left .navbar-brand {\n    height: 100%;\n}\n.orderpage-configuration .card{\nborder: none;\nmargin: 3px;\n}\n.orderpage-configuration .card-body.item\n{\npadding: 2px;\n}\n\ninput[type=checkbox]:checked:after, input[type=checkbox]:checked::after, input[type=radio]:checked:after, input[type=radio]:checked::after {\n    background: #0693e3;\n    border: 2px solid #0693e3;\n}\n\n.leftnavigation-box .nav-item .nav-link img {\n    display: inline-block !important;\n}\n.tab-content {\n    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 2px 24px rgba(0, 0, 0, 0.08);\n}\n.loyalty-info {\n    background-color: #e2edf9;\n    padding: 15px;\n    border: 1px solid #cadaec;\n    font-size: 14px;\n}\n.txt-green {\n    color: #1eba5c;\n    margin-right: 5px;\n}\n\n.loyalty-info .list-group-ui-base {\n    padding: 0;\n    margin: 0;\n}\n.loyalty-info .table thead th {\n\tborder-bottom: 2px solid #ddd;\n\tfont-size: 15px;\n}\n\n\n/**custom**/\n.navbar  form.navbar-search .input-group {\n    position: relative;\n    display: flex;\n    align-items: center;\n    /*width: 500px !important;*/\n    padding: 10px 20px !important;\n}\n\n.navbar input#navbar-search-box {\n    background-color: transparent;\n    border: 1px solid #0693e3 !important;\n    height: 40px !important;\n}\n\n.navbar .input-group-prepend.input-icon-placeholder {\n    position: absolute;\n    right: 22px;\n    height: 40px !important;\n}\n\n.navbar .input-group-prepend.input-icon-placeholder span.navbar-search-icon.input-group-text {\n    height: 40px !important;\n    background: #0693e3 !important;\n    width: 40px !important;\n    padding: 0px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 0px !important;\n}\n\n.navbar .input-group-prepend.input-icon-placeholder span.navbar-search-icon.input-group-text i{\n    color:#fff !important;\n}\n\n.navbar .navbar-body .navbar-menu .nav-item a i {\n    color: #0693e3 !important;\n}\n\n.navbar .navbar-body .navbar-menu .nav-link {\n    color: #333 !important;\n    border: 0px !important;\n    position:relative;\n}\n\n.navbar .navbar-body .navbar-menu .nav-item a.nav-link:before {\n    position: absolute;\n    content: '';\n    height: 20px;\n    width: 1px;\n    background: #EBECF0;\n    right: 0px;\n}\n\n.root-boxes .root-box {\n    border-width: 2px !important;\n    height: 280px;\n    padding: 20px !important;\n}\n\n.root-boxes .root-box h4 {\n    text-transform: uppercase;\n    font-size: 22px;\n    margin: 0;\n    font-weight: 500;\n    color: #000;\n}\n\n\n.root-boxes .root-box span {\n    text-align: center;\n    margin: 20px 0 0 0;\n}\n\n.section-main h1,section.section-main h2 {\n    color: #0693e3 !important;\n    text-transform: uppercase;\n    font-size: 28px;\n    font-weight: 700;\n}\n.orderpage .card .card-title {\n    color: #fff !important;\n    font-size: 16px;\n    font-weight: 700 !important;\n}\n.orderpage-domain_2019 .card .card-title {\n    color: #0573b1 !important;\n    font-size: 22px;\n}\n.navbar-order a {\n    margin-right: 0px !important;\n}\n\n.navbar .navbar-body .navbar-search .input-group .input-icon-placeholder span.navbar-search-icon.input-group-text {\n    padding: 0px !important;\n}\n\n.navbar .dropdown-order-items.show {\n    margin: 0;\n}\n\ndiv#orderpage h1, div#orderpage h2 {\n    color: #fff !important;\n}\n\n/** update menu**/\n.dropdown-item{\ncolor: #222222;\n}\n.dropdown .dropdown-item {\nfont-size: 15px;\n}\n.dropdown-menu.dropdown-menu-right.show{\nbox-shadow: 0px 0px 15px rgb(0 0 0 / 25%);\nborder-radius: 6px;\n}\n.dropdown-menu.dropdown-menu-right.show:after {\n    position: absolute;\n    content: \"\";\n    width: 0px;\n    height: 0px;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid #fff;\n    top: -10px;\n    right: 20px;\n}\n\n\n.bkns-sale {\n    width: 100%;\n    margin: calc(30px + 40px) auto 30px auto;\n    display: flex;\n    padding:10px;\n    align-items: center;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);\n}\n\n.bkns-sale ul li {\n        position: relative;\n    padding-left: 15px;\n    display: inline-block;\n}\n\n.bkns-sale ul {\n    margin: 0px !important;\n}\n\n.bkns-sale ul li a {\n    font-size: 16px;\n    color: #000;\n}\n\n.bkns-sale ul li:before {\n    content: \"\";\n    width: 5px;\n    height: 5px;\n    background: #0693e3 !important;\n    display: inline-block;\n    position: absolute;\n    left: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.bkns-sale .banner_sales {\n    padding: 5px 5px 8px 5px;\n    background: transparent;\n    display: flex;\n    width: 150px !important;\n    text-align: center;\n    border: 1px dashed #ff0000;\n    justify-content: center;\n    align-items: center;\n        margin-left: 50px;\n}\n\n.bkns-sale ul li a p {\n    margin: 0px !important;\n}\n\n.bkns-sale .banner_sales strong {\n    font-size: 18px;\n    line-height: 22px;\n    color: #ff0000;\n    font-weight: 700;\n    margin: 0px 10px 0px 0px;\n}\n\n.banner_sales figure {\n    margin: 0;\n    position: relative;\n}\n\n.banner_sales sup {\n   color: #fff;\n    position: absolute;\n    left: 50%;\n    top: 65%;\n    transform: translate(-50%,-50%);\n    font-size: 15px;\n}\n\n.btn-sm {\n    padding: 10px 15px !important;\n    font-size: 15px !important;\n}\n\n.navbar .navbar-body .navbar-search {\n    /*width: auto !important;*/\n}\n\n.navbar-right {\n    display: flex;\n    align-items: center;\n}\n\n.btn {\n    border-radius: 0px !important;\n}\n\n.bkns-sale ul li{\n    margin-right:50px !important;\n}\n@media only screen and (max-width:768px){\n    .bkns-sale {\n    margin: 0;\n    display: flex;\n}\n\n.bkns-sale .banner_sales strong {\n    display: none;\n}\n\n.bkns-sale .banner_sales {\n    width: 50px !important;\n}\n}\n\n@media (min-width: 994px) {\n    body .body-content .section-main {\n        margin: calc(30px + 0px) auto 0px auto !important;\n    }\n    \n}\n    .navbar form.navbar-search .input-group{\n        /*max-width: 300px !important;*/\n    }\n\n   \n\n\n\n    .bank-table {\n        width: 100%;\n        border-collapse: collapse;\n        margin-top: 15px;\n        font-size: 14px;\n    }\n    \n    .bank-table th,\n    .bank-table td {\n        padding: 10px;\n        border: 1px solid #ddd;\n        text-align: center;\n    }\n    \n    .bank-table th {\n        background-color: #f5f5f5;\n        font-weight: bold;\n    }\n    \n    .bank-table img {\n        display: block;\n        margin: 0 auto;\n    }\n    \n\n    .transfer-btn {\n        font-size: 12px; /* Giảm kích thước chữ */\n        background-color: #28a745;\n        color: white;\n        border: none;\n        border-radius: 3px;\n        cursor: pointer;\n        text-align: center;\n    }\n    \n    .transfer-btn:hover {\n        background-color: #218838;\n    }\n    \n    \n    .payment-notice {\n        width: 21cm; \n        margin: 0 auto;\n        padding: 20px;\n        line-height: 1.2;\n        font-size: 14px; \n        font-family: Arial, sans-serif; \n        color: #000; \n        background-color: white; \n        box-shadow: none;\n        position: relative;\n        /* top: -300px;  */\n    }\n    \n        \n    .bank-table\n    {\n        width: 21cm; /* Chiều rộng khổ A4 */\n        margin: 0 auto;\n        position: relative;\n        /* top: -300px;  */\n    }\n\n\n\n    .loading-spinner {\n        background-color: transparent !important;\n    }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
